import './FormRow.scss';

interface FormRowProps {
  children: React.ReactNode;
}

export default function FormRow({ children }: FormRowProps) {
  return <div className='form-row'>{children}</div>;
}
